<script setup lang="ts">
    import type { QrCode } from './qrCodeOutput';

    defineProps<{
        qrCode: QrCode;
        showInstruction: boolean;
    }>();
</script>

<template>
    <div class="qr-code">
        <p v-if="showInstruction">{{ $t('formElement.qrCodeInstruction') }}</p>
        <img
            class="qr-code-image"
            :src="qrCode.svgDataUrl"
            :alt="$t('formElement.qrCodeAlt')"
        />
        <DownloadLink
            v-if="qrCode.pngDataUrl"
            class="qr-code-download"
            :url="qrCode.pngDataUrl"
            :name="$t('formElement.qrCodeDownload')"
            type="png"
            download="qr-code.png"
        />
    </div>
</template>

<style scoped lang="scss">
    .qr-code-image {
        display: block;
        inline-size: min(100%, 16rem);
        block-size: auto;
    }

    .qr-code-download {
        margin-block-start: 1rem;
    }
</style>
